namespace Gamification.Administration {
    export interface UserRow {
        UserId?: number;
        IdParent?: number;
        IdAzienda?: number;
        Username?: string;
        IdentifierUser?: string;
        Cognome?: string;
        Nome?: string;
        DisplayName?: string;
        Email?: string;
        Source?: string;
        PasswordHash?: string;
        PasswordSalt?: string;
        MobilePhoneNumber?: string;
        MobilePhoneVerified?: boolean;
        TwoFactorAuth?: TwoFactorAuthType;
        UserImage?: string;
        LastDirectoryUpdate?: string;
        Locked?: number;
        IsActive?: number;
        Password?: string;
        PasswordConfirm?: string;
        ImpersonationToken?: string;
        Roles?: number[];
        IdAziendaRagioneSociale?: string;
        Api?: number[];
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace UserRow {
        export const idProperty = 'UserId';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Username';
        export const localTextPrefix = 'Administration.User';
        export const lookupKey = 'Administration.User';

        export function getLookup(): Q.Lookup<UserRow> {
            return Q.getLookup<UserRow>('Administration.User');
        }
        export const deletePermission = 'Role:SuperAdmin';
        export const insertPermission = 'Role:SuperAdmin';
        export const readPermission = 'Role:SuperAdmin';
        export const updatePermission = 'Role:SuperAdmin';

        export declare const enum Fields {
            UserId = "UserId",
            IdParent = "IdParent",
            IdAzienda = "IdAzienda",
            Username = "Username",
            IdentifierUser = "IdentifierUser",
            Cognome = "Cognome",
            Nome = "Nome",
            DisplayName = "DisplayName",
            Email = "Email",
            Source = "Source",
            PasswordHash = "PasswordHash",
            PasswordSalt = "PasswordSalt",
            MobilePhoneNumber = "MobilePhoneNumber",
            MobilePhoneVerified = "MobilePhoneVerified",
            TwoFactorAuth = "TwoFactorAuth",
            UserImage = "UserImage",
            LastDirectoryUpdate = "LastDirectoryUpdate",
            Locked = "Locked",
            IsActive = "IsActive",
            Password = "Password",
            PasswordConfirm = "PasswordConfirm",
            ImpersonationToken = "ImpersonationToken",
            Roles = "Roles",
            IdAziendaRagioneSociale = "IdAziendaRagioneSociale",
            Api = "Api",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
